export const APPLICANT_STATUS_OPTIONS = [
  { value: 'new_lead', label: 'New Lead' },
  { value: 'unable_to_send_message', label: 'Unable to Send Message' },
  { value: 'initial_msg_sent', label: 'Initial Msg Sent' },
  { value: 'interviewed', label: 'Interviewed' },
  { value: 'offered', label: 'Offered' },
  { value: 'hired', label: 'Hired' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'on_hold', label: 'On Hold' }
];

export const NOTE_REQUIRED_STATUSES = ['interviewed', 'rejected'];

export const getApplicantStatusLabel = (status) => {
  const matchedStatus = APPLICANT_STATUS_OPTIONS.find((option) => option.value === status);
  return matchedStatus?.label || 'Unknown Status';
};

export const getApplicantStatusColor = (status) => {
  const colors = {
    new_lead: 'bg-indigo-100 text-indigo-800',
    unable_to_send_message: 'bg-amber-100 text-amber-800',
    initial_msg_sent: 'bg-blue-100 text-blue-800',
    interviewed: 'bg-yellow-100 text-yellow-800',
    offered: 'bg-purple-100 text-purple-800',
    hired: 'bg-green-100 text-green-800',
    rejected: 'bg-red-100 text-red-800',
    on_hold: 'bg-gray-100 text-gray-800'
  };

  return colors[status] || 'bg-gray-100 text-gray-800';
};

export const appendStatusNote = (existingNotes, status, newNote) => {
  const trimmedNote = String(newNote || '').trim();
  if (!trimmedNote) return existingNotes || '';

  const statusLabel = getApplicantStatusLabel(status);
  const timestamp = new Date().toLocaleString();
  const noteBlock = `[${statusLabel} - ${timestamp}]\n${trimmedNote}`;

  return existingNotes && String(existingNotes).trim()
    ? `${String(existingNotes).trim()}\n\n${noteBlock}`
    : noteBlock;
};
